<template>
  <div style="text-align: center">
    <div v-if="!success">
      <div style="width: 360px;margin: 0 auto;">
        <div class="content">
          <div>
            <h3 style="color: crimson">付款请截图二维码使用{{channelName}}</h3>
            <h3 style="color: crimson">一单只能付款一次，不可重复付款</h3>
            <div v-if="payUrl !== ''">
              <b style="font-size: 45px">￥ {{ amount }}</b>
              <div>
                <vueQr :text="payUrl" :size="240"/>
              </div>
              <div><b style="font-size: 30px">二维码过期倒计时【{{ minute }}:{{ second }}】</b></div>
            </div>
            <h3 style="color: crimson">请打开{{ channelName }}使用 “扫一扫” 扫码付款</h3>
            <h3 style="color: coral">遇到问题联系平台客服</h3>
          </div>
        </div>
      </div>
    </div>
    <div v-if="success">
      <h1 style="font-size: 60px;color: #42b983">支付成功</h1>
    </div>
  </div>
</template>

<script>
import {payOrder, checkOrderStatus, pageStay} from '@/api/api'
import vueQr from 'vue-qr'

const wayCodes = {
  'ali_qr': '支付宝',
  'up_qr': '云闪付'
}
export default {
  components: {vueQr},
  data: function () {
    return {
      channelName: '',
      order: null,
      timeSpent: 0,
      success: false,
      payUrl: "",
      loadKey: -1,
      checkKey: -1,
      countdownKey: -1,
      amount: '00.00',
      minute: '05',
      second: '00'
    }
  },
  mounted() {
    this.pay();
  },
  methods: {
    pay: function () {
      const { wayCode, orderNo } = this.$router.history.current.params;
      this.channelName = wayCodes[wayCode.toLowerCase()];
      payOrder(orderNo).then(res => {
        this.payUrl = res.codeUrl
        const _order = JSON.parse(res.resData);
        this.amount = _order.amount;
        this.checkPayStatus(orderNo)
        this.countdown()
        this.trackPageTime(_order.payOrderId)
      });
    },
    checkPayStatus: function (orderNo) {
      this.checkKey = setInterval(() => {
        checkOrderStatus(orderNo).then(() => {
          this.success = true
          clearInterval(this.checkKey)
        })
      }, 5000)
      setTimeout(() => clearInterval(this.checkKey), 300000)
    },
    stop: function (){
      if (this.loadKey > -1) {
        clearTimeout(this.loadKey)
      }
      if (this.checkKey > -1) {
        clearInterval(this.checkKey)
      }
      if (this.delayKey > -1) {
        clearTimeout(this.delayKey)
      }

    },
    trackPageTime :function (orderNo) {
      pageStay(orderNo).then(() => {})
    },
    countdown: function (){
      this.countdownKey = setInterval(() => {
        let _minute = parseInt(this.minute);
        let _second = parseInt(this.second);
        if (_second > 0) {
          _second--
          this.minute = `0${_minute}`
          this.second = _second > 9 ? `${_second}` : `0${_second}`
        } else {
          if (_minute > 0) {
            _minute--
            this.minute = _minute > 9 ? `${_minute}` : `0${_minute}`
            this.second = '59'
          } else {
            this.minute = '00'
            this.second = '00'
            clearInterval(this.countdownKey)
            this.stop()
          }
        }
      }, 1000)
    }
  },
  beforeDestroy() {
    window.addEventListener('unload', this.stop);
    window.addEventListener('beforeunload', this.stop);
  },
}
</script>

<style scoped>
.pay-btn {
  background-color: red;
  color: white;
  border: none;
  padding: 5px 30px;
}

.pay-btn:active {
  background-color: rgba(255, 0, 0, 0.6);
}

.pay-btn.disable {
  background-color: #6b6b6b;
}

.content {
  margin-top: 15px;
}
</style>